module.exports = __webpack_public_path__ + "static/media/cookie-background.8ff17246.png";